<div>
  <strong class="text-blue d-inline-block mb-2">{{ contractInfos().title }}</strong>
</div>
@if (contractInfos()?.startDate?.length) {
  <div class="mb-1">
    <strong>{{ 'summary.contract.start' | translate }}:</strong> {{ contractInfos().startDate | date: 'dd.MM.yyyy' }}
    @if (contractInfos()?.contractStartDateDetailedInfo) {
      <mwe-info-text-icon
        [infoTextTitle]="'summary.contract.start' | translate"
        [infoTextDescription]="contractInfos()?.contractStartDateDetailedInfo"
        modalSize="lg"
      />
    }
  </div>
}
@if (contractInfos()?.commitment?.length) {
  <div class="mb-1">
    <strong>{{ 'summary.contract.commitment' | translate }}:</strong> {{ contractInfos().commitment }}
  </div>
}
@if (contractInfos()?.priceGuaranteeDate?.length) {
  <div class="mb-1">
    <strong>{{ 'summary.contract.price-guarantee' | translate }}:</strong>
    {{ contractInfos().priceGuaranteeDate | date: 'dd.MM.yyyy' }}
  </div>
}
@if (showDeliveryInfos() && contractInfos()?.startDelivery?.length) {
  <div>
    <strong>{{ 'summary.contract.start-delivery' | translate }}:</strong>
    @if (isDeliveryDate()) {
      {{ contractInfos()?.startDelivery | date: 'dd.MM.yyyy' }}
    } @else {
      {{ contractInfos()?.startDelivery | translate }}
    }
    <mwe-info-text-icon
      [infoTextTitle]="'summary.contract.start-delivery-info.title' | translate"
      [infoTextDescription]="'summary.contract.start-delivery-info.description' | translate"
      modalSize="lg"
    />
  </div>
}
